export const APP_VERSION = '2.9.23';
export const APP_BUILD_DATE = '2026-10-16';
